module.exports = __webpack_public_path__ + "img/L_8C.06c4634c.png";